<div class="mini-wrapper">
  <div class="sub-wrapper">
    <h1 class="landing text-center mb-4">{{ 'esia-token-and-scope.title' | transloco }}</h1>
    <h3 class="landing">{{ 'esia-token-and-scope.textInTime' | transloco }}</h3>
    <h3 class="landing">{{ 'esia-token-and-scope.textDontCloce' | transloco }}</h3>
    <div *ngIf="isLoading" class="col-12">
      <mat-spinner [diameter]="100" class="mt-5 m-auto"></mat-spinner>
    </div>
  </div>
</div>
